export const IsInternalApp = () => {
  var UA = navigator.userAgent || navigator.vendor || window.opera;

  var isLINE = function (UA) {
      return (UA.indexOf("Line/") > -1);
  }

  var isFacebook = function (UA) {
      return (UA.indexOf("FBAN") > -1) || (UA.indexOf("FBAV/") > -1);
  }

  if (isLINE(UA)) {
      return 'LINE';
  }

  if (isFacebook(UA)) {
      return 'Facebook'
  }

  return false;
}